import { render, staticRenderFns } from "./data-left.vue?vue&type=template&id=0f7f5b68&scoped=true&"
import script from "./data-left.vue?vue&type=script&lang=ts&"
export * from "./data-left.vue?vue&type=script&lang=ts&"
import style0 from "./data-left.vue?vue&type=style&index=0&id=0f7f5b68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7f5b68",
  null
  
)

export default component.exports